export default __webpack_public_path__ + "static/media/MongoDB.e7318c64.svg";